import { patchInvoiceEpic } from "./epics"
import { combineEpics } from "redux-observable"

export const invoiceEpics = combineEpics(patchInvoiceEpic)


// WEBPACK FOOTER //
// ./src/state/invoice/epics/index.ts